<!-- src/shared/components/ui/CornerBrackets.vue -->

<script setup lang="ts">
  // Decorative corner brackets from the seuid.com.br design (Figma Make).
  // Absolutely positioned — the parent must be `relative`.
</script>

<template>
  <span
    v-for="pos in ['tl', 'tr', 'bl', 'br']"
    :key="pos"
    class="pointer-events-none absolute size-3.5 border-brand-500"
    :class="{
      'left-0 top-0 border-l-2 border-t-2': pos === 'tl',
      'right-0 top-0 border-r-2 border-t-2': pos === 'tr',
      'bottom-0 left-0 border-b-2 border-l-2': pos === 'bl',
      'bottom-0 right-0 border-b-2 border-r-2': pos === 'br',
    }"
    aria-hidden="true"></span>
</template>
